import { render, staticRenderFns } from "./LocalOcorrenciaObitoSV.vue?vue&type=template&id=5882d1f6&scoped=true&"
import script from "./LocalOcorrenciaObitoSV.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrenciaObitoSV.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrenciaObitoSV.vue?vue&type=style&index=0&id=5882d1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882d1f6",
  null
  
)

export default component.exports